/* APS — shared front-end behavior: reveal-on-scroll, custom cursor, FAQ, lookbook carousel, wishlist, card flip */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;

  function initReveal() {
    var els = document.querySelectorAll('[data-aps-reveal]');
    if (!els.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseFloat(el.getAttribute('data-aps-reveal-delay') || '0');
        el.style.transitionDelay = delay + 's';
        el.classList.add('is-visible');
        io.unobserve(el);
      });
    }, { rootMargin: '-8% 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCursor() {
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    var dot = document.getElementById('aps-cursor-dot');
    var ring = document.getElementById('aps-cursor-ring');
    if (!dot || !ring) return;
    var mx = -100, my = -100, rx = -100, ry = -100, shown = false;

    window.addEventListener('pointermove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!shown) { shown = true; dot.style.opacity = '1'; ring.style.opacity = '1'; }
      dot.style.left = mx + 'px'; dot.style.top = my + 'px';
      var hot = e.target.closest('a, button, [role="button"], input, .aps-btn, [data-cursor-hot]');
      if (hot) {
        dot.style.width = '5px'; dot.style.height = '5px';
        ring.style.width = '60px'; ring.style.height = '60px';
      } else {
        dot.style.width = '8px'; dot.style.height = '8px';
        ring.style.width = '40px'; ring.style.height = '40px';
      }
    }, { passive: true });

    window.addEventListener('pointerleave', function () {
      dot.style.opacity = '0'; ring.style.opacity = '0'; shown = false;
    });

    function tick() {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initMagnetic() {
    if (isTouch || reducedMotion) return;
    var els = document.querySelectorAll('.aps-btn');
    if (!els.length) return;
    els.forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var relX = e.clientX - r.left - r.width / 2;
        var relY = e.clientY - r.top - r.height / 2;
        el.style.transform = 'translate(' + (relX * 0.16).toFixed(1) + 'px,' + (relY * 0.32).toFixed(1) + 'px)';
      }, { passive: true });
      el.addEventListener('pointerleave', function () {
        el.style.transform = '';
      });
    });
  }

  function initHeroParallax() {
    if (isTouch || reducedMotion) return;
    var hero = document.querySelector('.aps-hero');
    var img = document.querySelector('.aps-hero__img img');
    if (!hero || !img) return;
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      var relX = (e.clientX - r.left) / r.width - 0.5;
      var relY = (e.clientY - r.top) / r.height - 0.5;
      img.style.transform = 'translate(' + (relX * -16).toFixed(1) + 'px,' + (relY * -12).toFixed(1) + 'px)';
    }, { passive: true });
    hero.addEventListener('pointerleave', function () {
      img.style.transform = '';
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-aps-faq]').forEach(function (faq) {
      var items = faq.querySelectorAll('.aps-faq__item');
      items.forEach(function (item) {
        var btn = item.querySelector('.aps-faq__q');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (i) {
            i.classList.remove('is-open');
            var b = i.querySelector('.aps-faq__q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  function initWishlist() {
    document.querySelectorAll('.aps-card__wish').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var active = btn.classList.toggle('is-active');
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (!reducedMotion) {
          btn.classList.remove('is-pulsing');
          // force reflow so the animation can re-trigger on rapid re-clicks
          void btn.offsetWidth;
          btn.classList.add('is-pulsing');
          btn.addEventListener('animationend', function handler() {
            btn.classList.remove('is-pulsing');
            btn.removeEventListener('animationend', handler);
          });
        }
      });
    });
  }

  function initCardFlip() {
    if (!isTouch) return;
    document.querySelectorAll('.aps-card').forEach(function (card) {
      var link = card.querySelector(':scope > a');
      var media = card.querySelector('.aps-card__media');
      var back = card.querySelector('.aps-card__img--back');
      if (!link || !media || !back) return;
      link.addEventListener('click', function (e) {
        if (!card.classList.contains('is-flipped')) {
          e.preventDefault();
          document.querySelectorAll('.aps-card.is-flipped').forEach(function (c) {
            if (c !== card) c.classList.remove('is-flipped');
          });
          card.classList.add('is-flipped');
        }
      });
    });
  }

  function initLookbook() {
    document.querySelectorAll('[data-aps-lookbook]').forEach(function (lb) {
      var track = lb.querySelector('[data-aps-lookbook-track]');
      var prev = lb.querySelector('[data-aps-lookbook-prev]');
      var next = lb.querySelector('[data-aps-lookbook-next]');
      var row = lb.closest('.aps-lookbook__row') || lb;
      if (!track) return;
      var cells = Array.prototype.slice.call(track.children);
      var n = cells.length;
      if (!n) return;
      var index = Math.floor(n / 2);
      var animating = false;

      function paint() {
        cells.forEach(function (cell) {
          cell.classList.remove('aps-lookbook__cell--center', 'aps-lookbook__cell--side');
          cell.style.display = 'none';
        });
        [-1, 0, 1].forEach(function (offset) {
          var idx = ((index + offset) % n + n) % n;
          var cell = cells[idx];
          cell.style.display = '';
          cell.classList.add(offset === 0 ? 'aps-lookbook__cell--center' : 'aps-lookbook__cell--side');
        });
      }

      function go(direction) {
        if (animating) return;
        index = direction === 'next' ? index + 1 : index - 1;
        if (reducedMotion) { paint(); return; }
        animating = true;
        track.style.opacity = '0';
        track.style.transform = direction === 'next' ? 'translateX(-14px)' : 'translateX(14px)';
        setTimeout(function () {
          paint();
          track.style.transition = 'none';
          track.style.transform = direction === 'next' ? 'translateX(14px)' : 'translateX(-14px)';
          requestAnimationFrame(function () {
            track.style.transition = 'opacity .28s ease, transform .28s ease';
            track.style.opacity = '1';
            track.style.transform = 'none';
            setTimeout(function () { animating = false; }, 300);
          });
        }, 220);
      }

      paint();
      if (prev) prev.addEventListener('click', function () { go('prev'); });
      if (next) next.addEventListener('click', function () { go('next'); });

      // keyboard
      row.setAttribute('tabindex', row.getAttribute('tabindex') || '0');
      row.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go('prev'); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go('next'); }
      });

      // swipe
      var startX = null, startY = null;
      track.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        startX = t.clientX; startY = t.clientY;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        startX = null; startY = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        go(dx < 0 ? 'next' : 'prev');
      }, { passive: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCursor();
    initMagnetic();
    initHeroParallax();
    initFaq();
    initWishlist();
    initCardFlip();
    initLookbook();
  });
})();
